module.exports = __webpack_public_path__ + "static/img/liuc.36e14853.png";